<template>
    <div class="mt-4" v-if="insurance">
        <div class="card course-calculator-card card-watermark" :style="errors.insurance_checker ? 'border: 2px solid red;' : '' + ` --logo-url: url(${base_url}/storage/logo.png)`">
            <Accordion value="0">
                <AccordionPanel value="0">
                    <AccordionHeader>
                        <div class="accordion-header-content">
                            <div class="d-flex align-items-start">
                                <i class="fal fa-shield-check component-header-icon mt-0"></i>
                                <div>
                                    <h2 class="component-title">{{ tra.insurance }}</h2>
                                    <p class="component-sub-title">{{ tra.do_you_need_insurance }}</p>
                                    <p v-if="errors.insurance_checker" class="text-danger">{{ errors.insurance_checker[0] }}</p>
                                </div>
                            </div>
                        </div>
                    </AccordionHeader>
                    <AccordionContent>
                        
                        <div class="row align-items-end course-row py-2 justify-content-between">
                            <div class="col-12">
                                <div class="d-flex align-items-start">
                                    <RadioButton class="ml-3" v-model="insuranceCheckerValue" :value="0" />
                                    <div>
                                        <h2 class="course-title">{{ tra.no_insurance }}</h2>
                                        <p class="course-sub-title">{{ tra.no_need_insurance }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-end course-row py-2 justify-content-between">
                            <div class="col-md-auto">
                                <div class="d-flex align-items-start">
                                    <RadioButton class="ml-3" v-model="insuranceCheckerValue" :value="1" />
                                    <h2 class="course-title">{{ tra.yes_need_insurance }}</h2>
                                </div>
                            </div>
                            <div class="col-md-auto" style="padding-right: 52px;">
                                <div class="price-info d-flex align-items-end justify-content-md-end mt-2">
                                    <p class="price mb-0" dir="ltr">
                                        {{ insurance?.prices?.insurance_price_formated }}  / {{ weeksOutput(courseWeeks ?? 1) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        </div>
    </div>
</template>

<script>
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import RadioButton from 'primevue/RadioButton';
import debounce from 'lodash/debounce';

export default {
    components: {
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent,
        RadioButton,
    },
    props: ['institute_id', 'base_url', 'pref_currency', 'insuranceChecker', 'courseWeeks', 'start_date', 'errors', 'old', 'tra'],
    emits: ['update:insuranceChecker', 'update:insuranceAvailability'],
    data() {
        return {
            insurance: null,
            lang: window.current_locale,
            insuranceAbortController: null,
        };
    },
    methods: {
        getInsurance() {
            // Cancel previous request if exists
            if (this.insuranceAbortController) {
                this.insuranceAbortController.abort();
            }

            // Create new AbortController for this request
            this.insuranceAbortController = new AbortController();

            axios.get(this.base_url + '/api/get-insurance', {
                signal: this.insuranceAbortController.signal,
                params: {
                    institute_id: this.institute_id,
                    weeks: this.courseWeeks ?? 1,
                    start_date: this.start_date,
                    pref_currency: this.pref_currency,
                },
            }).then((response) => {
                this.insurance = response.data;
                // Emit insurance data to parent whenever it's updated
                this.$emit('update:insuranceAvailability', this.insurance ? true : false);
            }).catch((error) => {
                // Ignore cancelled requests
                if (error.code === 'ERR_CANCELED' || error.message === 'canceled') {
                    console.log('Insurance request cancelled - new request started');
                    return;
                }
                console.error('Error fetching insurance:', error);
            });
        },

        createDebouncedMethods() {
            this.debouncedGetInsurance = debounce(this.getInsurance, 500);
        },

        weeksOutput(weeks) {
            if (weeks == 1) {
                return this.tra.week;
            } else if (weeks == 2) {
                return this.tra.two_weeks;
            } else {
                return weeks + ' ' + this.tra.weeks;
            }
        }
    },
    computed: {
        insuranceCheckerValue: {
            get() {
                return this.insuranceChecker !== null ? Number(this.insuranceChecker) : null;
            },
            set(value) {
                this.$emit('update:insuranceChecker', value);
            }
        },
    },
    watch: {
        courseWeeks: {
            handler() {
                this.debouncedGetInsurance();
            },
            immediate: false
        },
        start_date: {
            handler() {
                this.debouncedGetInsurance();
            },
            immediate: false
        },
        insurance: {
            handler(newInsurance) {
                if (newInsurance) {
                    this.$emit('update:insuranceAvailability', newInsurance ? true : false);
                }
            },
            deep: true
        }
    },
    created() {
        this.createDebouncedMethods();
    },
    mounted() {
        this.getInsurance();
        if (this.old.insurance_checker) {
            this.insuranceCheckerValue = Number(this.old.insurance_checker);
        }
    },
};
</script>